import { type ObjectValuesUnionType } from '../../utils/typing';

export const MyMatchActionTypes = Object.freeze({
  TOGGLE_MATCH_VIEW_MODE_SWITCH: 'MY_MATCH:TOGGLE_MATCH_VIEW_MODE_SWITCH',
  GET_ODDS: 'MY_MATCH:GET_ODDS',
  GET_ODDS_RESPONSE_RECEIVED: 'MY_MATCH:GET_ODDS_RESPONSE_RECEIVED',
  GET_FUTURE_ODDS: 'MY_MATCH:GET_FUTURE_ODDS',
  REQUEST_ADD_WITH_MERGE: 'MY_MATCH:REQUEST_ADD_WITH_MERGE',
  REQUEST_DELETION_WITH_MERGE: 'MY_MATCH:REQUEST_DELETION_WITH_MERGE',
  MERGE: 'MY_MATCH:MERGE',
  SPLIT: 'MY_MATCH:SPLIT',
  REQUEST_OUTCOME_INJECTION: 'MY_MATCH:REQUEST_OUTCOME_INJECTION',
  INJECT_OUTCOME: 'MY_MATCH:INJECT_OUTCOME',
  REQUEST_OUTCOME_DELETION: 'MY_MATCH:REQUEST_OUTCOME_DELETION',
  REQUEST_MERGE: 'MY_MATCH:REQUEST_MERGE',
  REQUEST_SPLIT: 'MY_MATCH:REQUEST_SPLIT',

  REQUEST_TOGGLE_MY_MATCH_MODE: 'MY_MATCH:REQUEST_TOGGLE_MY_MATCH_MODE',
  SET_MY_MATCH_MODE: 'MY_MATCH:SET_MY_MATCH_MODE',
  UNSET_MY_MATCH_MODE: 'MY_MATCH:UNSET_MY_MATCH_MODE',
  RECEIVED_GET_FUTURE_ODDS_ENTITIES: 'MY_MATCH:RECEIVED_GET_FUTURE_ODDS_ENTITIES',
  RECEIVED_GET_FUTURE_ODDS_ENTITIES_UPDATES: 'MY_MATCH:RECEIVED_GET_FUTURE_ODDS_ENTITIES_UPDATES',
  INJECT_TOP_MY_MATCH_INTO_BASKET: 'MY_MATCH:INJECT_TOP_MY_MATCH_INTO_BASKET',

  CLEAR_MY_MATCH_MODE_MATCH_IDS: 'MY_MATCH:CLEAR_MY_MATCH_MODE_MATCH_IDS',
  REMOVE_MULTICHOICE_BET_SELECTION: 'MY_MATCH:REMOVE_MULTICHOICE_BET_SELECTION',
});
export type MyMatchActionType = ObjectValuesUnionType<typeof MyMatchActionTypes>;
